export const FETCH_POKEMON = 'FETCH_POKEMON';